import React from 'react'
import ReactModal from 'react-modal'

function ReportModal({uploadNew, onClose, onSubmit}) {
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 40
        },
        content: {
            height: 'auto',
            width: 'auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >    
        <div className='flex items-center flex-col my-8'>
            <div className='text-center'>Are you sure you want to Report this case ?<br/> <span className='text-xs'> Note that you will not see this case again on your profile</span><br/></div>
            <div className='flex w-full justify-center'>
                <div 
                className="shadow-xl text-sm w-[100px] h-8 mr-2 bg-red-700 hover:bg-red-800 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
                onClick={onSubmit}>Report</div>
                <div 
                className=" shadow-xl text-sm w-[100px] h-8 bg-gray-400 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer"
                onClick={onClose}>Do not report</div>
            </div>
         </div>
    </ReactModal>
  )
}

export default ReportModal